export const environment = {
  development: true,
  apiUrl: 'https://dev-apitrustbanking.normaxcapital.com/api/v1',
  appName: 'Normax Client Portal',
  googlePlacesApiKey: '',
  telemetry: {
    enabled: true,
    collectorUrl:
      'https://faro-collector-prod-ap-south-1.grafana.net/collect/e86ac153e3cae9f11eb7eac472b55c9f',
    environment: 'development',
  },
};
